(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._root_1qmy6_1{gap:var(--dixa-size-spacer-300);padding:var(--dixa-size-spacer-250) var(--dixa-size-spacer-300)}._content_1qmy6_6{align-items:center;gap:var(--dixa-size-spacer-300);display:flex}._colorIndicator_1qmy6_12{border-radius:50%;flex-shrink:0;width:8px;height:8px}._root_1bv8d_54._padded_1bv8d_54{padding:var(--dixa-size-spacer-300)}._root_1bv8d_54._scrollable_1bv8d_57{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:286px}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { Box as e, Column as t, Columns as n, EmptyState as r, FlexBox as i, Icon as a, SelectionList as o, Spinner as s, Text as c, TextWithHighlight as l, getSelectionListContext as u } from "@dixa/lib-shared-habla";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
import p from "classnames";
import { forwardRef as m, memo as h, useCallback as g, useContext as _ } from "react";
//#region src/components/filter/components/layout/components/empty/searchFilterLayoutEmpty.tsx
var v = () => /* @__PURE__ */ d(e, {
	as: "li",
	padding: "250 300",
	children: /* @__PURE__ */ d(r, {
		title: "No items found",
		description: "Try changing your search criteria."
	})
}), y = {
	root: "_root_1qmy6_1",
	content: "_content_1qmy6_6",
	colorIndicator: "_colorIndicator_1qmy6_12"
}, b = h(m(({ className: e, contentClassName: t, children: n, value: r, label: i, icon: s, highlight: m, textProps: h, ...v }, b) => {
	let { list: { isDisabled: x }, item: { onSelect: S } } = _(u()), C = g((e) => {
		!v.isDisabled && !x && S({
			value: r,
			meta: {
				target: e?.target,
				event: e || void 0
			}
		});
	}, [
		x,
		S,
		v.isDisabled,
		r
	]);
	return /* @__PURE__ */ f(o.Item, {
		ref: b,
		className: p(y.root, e),
		contentClassName: p(y.content, t),
		...v,
		value: r,
		onClick: C,
		children: [
			s && typeof s == "string" && /* @__PURE__ */ d(a, {
				name: s,
				color: "secondary"
			}),
			s && typeof s != "string" && s,
			/* @__PURE__ */ d(c.Paragraph, {
				...h,
				children: /* @__PURE__ */ d(l, {
					text: i,
					highlight: m
				})
			}),
			n
		]
	});
})), x = () => /* @__PURE__ */ d(i, {
	as: "li",
	padding: "250 300",
	alignItems: "center",
	justifyContent: "center",
	children: /* @__PURE__ */ d(s, { size: 20 })
}), S = {
	root: "_root_1bv8d_54",
	padded: "_padded_1bv8d_54",
	scrollable: "_scrollable_1bv8d_57"
}, C = m(function({ children: e, noPadding: n = !1, ...r }, i) {
	return /* @__PURE__ */ d(t.Row, {
		ref: i,
		className: p(S.root, {
			[S.padded]: !n,
			[S.scrollable]: r.scrollable
		}),
		noHorizontalPadding: !0,
		noVerticalPadding: !0,
		noMinHeight: !0,
		...r,
		children: e
	});
}), w = ({ children: e }) => /* @__PURE__ */ d(n, { children: /* @__PURE__ */ d(t, {
	size: "300px",
	children: e
}) });
w.Item = b, w.Row = C, w.Empty = v, w.Loading = x;
//#endregion
//#region src/utils/filter/filterField.ts
var T = {
	conversations: {
		numeric_id: {
			type: "string",
			label: "ID",
			description: "The id of the conversation.",
			icon: "code",
			enrichable: !1
		},
		status: {
			type: "string",
			label: "Status",
			description: "Whether the conversation is open, closed or in follow up.",
			icon: "lock",
			enrichable: !1
		},
		initial_channel: {
			type: "string",
			label: "Channel",
			description: "The channel the conversation originated from.",
			icon: "channels",
			enrichable: !1
		},
		initial_direction: {
			type: "string",
			label: "Direction",
			description: "Whether this is an inbound or outbound conversation.",
			icon: "exchange",
			enrichable: !1
		},
		queue_id: {
			type: "string",
			label: "Queue",
			description: "The current queue of the conversation.",
			icon: "users",
			enrichable: !0
		},
		agent_id: {
			type: "string",
			label: "Agent",
			description: "The agent currently assigned to the conversation.",
			icon: "headset",
			enrichable: !0
		},
		requested_by: {
			type: "string",
			label: "Contact",
			description: "The customer contact of the conversation.",
			icon: "id-card",
			enrichable: !0
		},
		tags: {
			type: "array",
			label: "Tag",
			description: "The tags that are currently applied to the conversation.",
			icon: "tag",
			enrichable: !0
		},
		duration: {
			type: "duration",
			label: "Duration",
			description: "The period from when the conversation was created until it was closed the last time, or time of search if the conversation is open.",
			icon: "clock",
			enrichable: !1
		},
		note_message: {
			type: "text",
			label: "Internal note",
			description: "The content of the internal note in the conversation.",
			icon: "sticky-note",
			enrichable: !1
		},
		note_author_id: {
			type: "string",
			label: "Internal note author",
			description: "The agent who wrote the internal note in the conversation.",
			icon: "headset",
			enrichable: !0
		},
		message_author_id: {
			type: "string",
			label: "Message author",
			description: "The agent who wrote the message in the conversation.",
			icon: "headset",
			enrichable: !0
		},
		abandoned_at: {
			type: "date",
			label: "Abandoned date",
			description: "The date when the conversation was abandoned.",
			icon: "calendar-times",
			enrichable: !1
		},
		assigned_at: {
			type: "date",
			label: "Assigned date",
			description: "The latest time the conversation was assigned to an agent.",
			icon: "calendar",
			enrichable: !1
		},
		closed_at: {
			type: "date",
			label: "Closed date",
			description: "The latest time the conversation was closed.",
			icon: "calendar-times",
			enrichable: !1
		},
		created_at: {
			type: "date",
			label: "Creation date",
			description: "The date when the conversation was created.",
			icon: "calendar-plus",
			enrichable: !1
		},
		last_message_created_at: {
			type: "date",
			label: "Last message",
			description: "The date when the last message was added to the conversation.",
			icon: "calendar-plus",
			enrichable: !1
		},
		updated_at: {
			type: "date",
			label: "Last activity",
			description: "The date when the last activity occurred on the conversation. Conversation activity is defined as one of the following events: internal note added, new message added, tag added, transferred or assigned to a queue or an agent.",
			icon: "calendar",
			enrichable: !1
		},
		note_created_at: {
			type: "date",
			label: "Internal note created date",
			description: "The date when the internal note was created.",
			icon: "calendar-plus",
			enrichable: !1
		},
		conversation_custom_attribute: {
			type: "custom_attribute",
			label: "Conversation custom attribute",
			description: "A custom attribute of the conversation.",
			icon: "input",
			enrichable: !1
		},
		link_type: {
			type: "string",
			label: "Linked type",
			description: "The type of the conversation link.",
			icon: "link",
			enrichable: !1
		},
		linked_to: {
			type: "string",
			label: "Linked to",
			description: "The conversation this is linked to.",
			icon: "link",
			enrichable: !0
		},
		is_abandoned: {
			type: "boolean",
			label: "Abandoned",
			description: "Whether the conversation was abandoned or not.",
			icon: "phone-hang",
			enrichable: !1
		}
	},
	companies: {
		id: {
			type: "string",
			label: "ID"
		},
		created_at: {
			type: "date",
			label: "Creation date"
		}
	},
	queues: {
		id: {
			type: "string",
			label: "ID"
		},
		name: {
			type: "text",
			label: "Name"
		},
		is_archived: {
			type: "boolean",
			label: "Archived"
		},
		is_default: {
			type: "boolean",
			label: "Default"
		},
		is_restricted: {
			type: "boolean",
			label: "Restricted"
		},
		agents: {
			type: "array",
			label: "Agents"
		},
		teams: {
			type: "array",
			label: "Teams"
		}
	},
	tags: {
		id: {
			type: "string",
			label: "ID"
		},
		type: {
			type: "string",
			label: "Type"
		},
		is_deactivated: {
			type: "boolean",
			label: "Deactivated"
		},
		name: {
			type: "text",
			label: "Name"
		}
	},
	teams: {
		id: {
			type: "string",
			label: "ID"
		},
		name: {
			type: "text",
			label: "Name"
		},
		is_deactivated: {
			type: "boolean",
			label: "Deactivated"
		},
		agents: {
			type: "array",
			label: "Agents"
		},
		queues: {
			type: "array",
			label: "Queues"
		},
		created_at: {
			type: "date",
			label: "Creation date"
		},
		updated_at: {
			type: "date",
			label: "Last updated"
		}
	},
	users: {
		id: {
			type: "string",
			label: "ID"
		},
		company_id: {
			type: "string",
			label: "Company"
		},
		email: {
			type: "string",
			label: "Email"
		},
		phone_number: {
			type: "string",
			label: "Phone number"
		},
		type: {
			type: "string",
			label: "Type"
		},
		user_type: {
			type: "string",
			label: "Category"
		},
		has_acw: {
			type: "boolean",
			label: "Wrap-up time"
		},
		is_assigned: {
			type: "boolean",
			label: "Assigned"
		},
		is_online: {
			type: "boolean",
			label: "Online"
		},
		is_working: {
			type: "boolean",
			label: "Working"
		},
		merged_into: {
			type: "array",
			label: "Merged into"
		},
		merged_users: {
			type: "array",
			label: "Merged users"
		},
		queues: {
			type: "array",
			label: "Queues"
		},
		roles: {
			type: "array",
			label: "Roles"
		},
		teams: {
			type: "array",
			label: "Teams"
		},
		name: {
			type: "text",
			label: "Name"
		},
		created_at: {
			type: "date",
			label: "Creation date"
		},
		contact_custom_attribute: {
			type: "custom_attribute",
			label: "Contact custom attribute"
		}
	},
	channels: {}
}, E = {
	is_one: "is one of",
	is_not_one: "is not one of",
	includes_one: "includes one of",
	excludes_one: "excludes one of",
	includes_all: "includes all of",
	excludes_all: "excludes all of",
	is_empty: "is empty",
	is_not_empty: "is not empty",
	between: "between",
	since: "since",
	until: "until",
	gte: "longer than or equal to",
	lte: "shorter than or equal to",
	contains: "contains",
	not_contains: "does not contain",
	equals: "equals",
	not_equals: "does not equal"
}, D = {
	string: ["is_one", "is_not_one"],
	array: [
		"includes_one",
		"excludes_one",
		"includes_all",
		"excludes_all"
	],
	existence: ["is_empty", "is_not_empty"],
	number: [
		"between",
		"gte",
		"lte"
	],
	text: ["contains", "not_contains"],
	date: [
		"between",
		"since",
		"until"
	],
	boolean: ["equals", "not_equals"]
}, O = {
	conversations: {
		numeric_id: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		status: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		initial_channel: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		initial_direction: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		requested_by: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		message_author_id: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		note_author_id: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		agent_id: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		},
		queue_id: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		},
		link_type: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		},
		linked_to: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		},
		tags: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		note_message: {
			defaultOperator: "contains",
			operators: [...D.string, ...D.text]
		},
		is_abandoned: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		duration: {
			defaultOperator: "between",
			operators: [...D.number]
		},
		conversation_custom_attribute: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		},
		abandoned_at: {
			defaultOperator: "between",
			operators: [...D.date]
		},
		assigned_at: {
			defaultOperator: "between",
			operators: [...D.date]
		},
		closed_at: {
			defaultOperator: "between",
			operators: [...D.date]
		},
		created_at: {
			defaultOperator: "between",
			operators: [...D.date]
		},
		last_message_created_at: {
			defaultOperator: "between",
			operators: [...D.date]
		},
		note_created_at: {
			defaultOperator: "between",
			operators: [...D.date]
		},
		updated_at: {
			defaultOperator: "between",
			operators: [...D.date]
		}
	},
	companies: {
		id: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		created_at: {
			defaultOperator: "between",
			operators: [...D.date]
		}
	},
	queues: {
		id: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		name: {
			defaultOperator: "contains",
			operators: [...D.string, ...D.text]
		},
		is_archived: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		is_default: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		is_restricted: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		agents: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		teams: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		}
	},
	tags: {
		id: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		type: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		is_deactivated: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		name: {
			defaultOperator: "contains",
			operators: [...D.string, ...D.text]
		}
	},
	teams: {
		id: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		name: {
			defaultOperator: "contains",
			operators: [...D.string, ...D.text]
		},
		is_deactivated: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		agents: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		queues: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		created_at: {
			defaultOperator: "between",
			operators: [...D.date]
		},
		updated_at: {
			defaultOperator: "between",
			operators: [...D.date]
		}
	},
	users: {
		id: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		company_id: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		},
		email: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		},
		phone_number: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		},
		type: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		user_type: {
			defaultOperator: "is_one",
			operators: [...D.string]
		},
		has_acw: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		is_assigned: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		is_online: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		is_working: {
			defaultOperator: "equals",
			operators: [...D.boolean]
		},
		merged_into: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		merged_users: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		queues: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		roles: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		teams: {
			defaultOperator: "includes_one",
			operators: [...D.array, ...D.existence]
		},
		name: {
			defaultOperator: "contains",
			operators: [...D.string, ...D.text]
		},
		created_at: {
			defaultOperator: "between",
			operators: [...D.date]
		},
		contact_custom_attribute: {
			defaultOperator: "is_one",
			operators: [...D.string, ...D.existence]
		}
	},
	channels: {}
};
//#endregion
//#region src/utils/filter/filterTypeGuards.ts
function k(e, t) {
	return Object.values(T).some((n) => n[e]?.type === t);
}
function A(e) {
	return "field" in e;
}
function j(e) {
	let t = e;
	return "strategy" in t && "filters" in t;
}
function M(e) {
	return D.existence.includes(e);
}
function N(e) {
	let t = e.field;
	return k(t, "date");
}
function P(e) {
	return k(e, "date");
}
function F(e) {
	let t = e.field;
	return k(t, "custom_attribute");
}
function I(e) {
	return k(e, "custom_attribute");
}
//#endregion
//#region src/utils/filter/convertFilters.ts
var L = {
	FIELD: "~",
	VALUES: ",",
	CONDITIONS: ";",
	CUSTOM_ATTRIBUTE_FIELD: ":",
	TIMEZONE: "@"
}, R = RegExp(`^(?:conversation|contact)_custom_attribute\\${L.CUSTOM_ATTRIBUTE_FIELD}.*$`), z = /\(([^)]+)\)/g;
function B(e) {
	if (!e?.filters.length) return "";
	try {
		let t = e.filters.filter(A).reduce((e, t) => {
			let { operator: n, values: r } = t;
			if (!r.length && !M(n)) return e;
			let i = r.length ? r.map(({ value: e }) => Array.isArray(e) ? `(${e.join(L.VALUES)})` : e).join(L.VALUES) : void 0, a = F(t) ? [t.field, t.attributeId].join(L.CUSTOM_ATTRIBUTE_FIELD) : t.field, o = N(t) && t.meta?.timezone ? t.meta.timezone : void 0;
			o && (i += `${L.TIMEZONE}${o}`);
			let s = [
				a,
				n,
				i
			].filter(Boolean).join(L.FIELD);
			return e.push(s), e;
		}, []);
		return t.length && t.unshift(`strategy${L.FIELD}${e.strategy}`), t.join(L.CONDITIONS);
	} catch {
		return "";
	}
}
function V(e) {
	let t = {
		strategy: "all",
		filters: []
	};
	if (!e) return t;
	try {
		let [n, ...r] = e.split(L.CONDITIONS), i = n.split(L.FIELD)[1];
		return ["all", "any"].includes(i) && (t.strategy = i), r.reduce((e, t) => {
			let [n, r, i] = t.split(L.FIELD);
			if (R.test(n)) {
				let [t, a] = n.split(L.CUSTOM_ATTRIBUTE_FIELD), o = [];
				if (i) if (z.test(i)) {
					let e = i.match(z);
					e?.length && o.push(...e.map((e) => ({
						label: "",
						value: e.slice(1, -1).split(L.VALUES)
					})));
				} else o.push(...i.split(L.VALUES).map((e) => ({
					label: e,
					value: e
				})));
				e.filters.push({
					field: t,
					operator: r,
					values: o,
					attributeId: a
				});
			} else {
				let t = i, a;
				if (t && P(n)) {
					let e = t.lastIndexOf(L.TIMEZONE);
					e !== -1 && (a = { timezone: t.slice(e + 1) }, t = t.slice(0, e));
				}
				let o = t ? t.split(L.VALUES).map((e) => ({
					label: "",
					value: e
				})) : [];
				e.filters.push({
					field: n,
					operator: r,
					values: o,
					...a && { meta: a }
				});
			}
			return e;
		}, t);
	} catch {
		return t;
	}
}
//#endregion
//#region src/utils/filter/filterStrategy.ts
var H = {
	all: {
		label: "ALL",
		description: "If all of the criteria are met"
	},
	any: {
		label: "ONE OR MORE",
		description: "If one or more of the criteria are met"
	}
};
//#endregion
export { w as SearchFilterLayout, B as convertFiltersObjectToString, V as convertFiltersStringToObject, T as filterFieldCatalogue, O as filterOperatorCatalogue, D as filterOperatorGroups, E as filterOperatorLabels, H as filterStrategyCatalogue, F as isCustomAttributeCondition, I as isCustomAttributeField, N as isDateFilterCondition, P as isDateFilterField, M as isExistenceFilterOperator, A as isLeafFilterCondition, j as isNestedFilterGroup };

//# sourceMappingURL=index.js.map